import { faImage } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';

const Root = styled(ButtonBase)`
  --logo-size: 100px;

  display: block;
  border-radius: 50%;
  width: var(--logo-size);
  height: var(--logo-size);
  background: var(--c-neutral-300);
  position: relative;
  margin: auto;
  padding: var(--unit);

  &:hover {
    background-color: var(--c-neutral-400);
  }

  &.overlap {
    margin-top: calc(var(--logo-size) / 2 * -1);
  }

  img {
    width: 100%;
    aspect-ratio: 1;
    object-fit: contain;
    padding: var(--unit);
  }
`;

type Props = {
  pictureUrl?: string | null;
  alt: string;
  onClick: () => void;
  overlap?: boolean;
};

export const Logo = ({ pictureUrl, alt, onClick, overlap }: Props) => {
  return (
    <Root className={classNames({ overlap })} onClick={onClick}>
      {pictureUrl ? (
        <img src={pictureUrl} alt={alt} />
      ) : (
        <FontAwesomeIcon icon={faImage} />
      )}
    </Root>
  );
};
